import { render, staticRenderFns } from "./PopupModalForm.vue?vue&type=template&id=9dfc144a"
import script from "./PopupModalForm.vue?vue&type=script&lang=js"
export * from "./PopupModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports